module.exports = __webpack_public_path__ + "assets/coin-9f4576df.gif";